<div class="charSheet" *ngIf="player" [ngClass]="{'zoomed': zoomed, 'newItem': gainingItem}">
	<div class="wounds">
		<div *ngFor="let wound of player.wounds" class="{{ wound.cardType === cardType.blank ? 'nocard' : 'card' }}">
			<p>{{ wound.cardName }}</p><p>Wound</p>
		</div>
	</div>
	<div class="avatar">
		<img src="assets/characters/{{ player.headshot }}">
		<h3>{{ player.name }}</h3>
	</div>
	<div class="charText">
		<p>{{ player.description }}</p>
		<p><strong>{{ player.powerName }}</strong><br>
		{{ player.powerDescription }}</p>
	</div>
	<div class="attributes">
		<dl>
			<dt [innerHTML]="player.displayStats.Brains" ></dt><dd>Brains</dd>
			<dt [innerHTML]="player.displayStats.Brawn"  ></dt><dd>Brawn</dd>
			<dt [innerHTML]="player.displayStats.Bravado"></dt><dd>Bravado</dd>
		</dl>
		<div *ngIf="player.XP.length" class="XP" hotmCardRatio>XP</div>
	</div>
	<div class="items">
		<div *ngFor="let item of player.items; let num = index" class="{{ item.cardType === cardType.blank ? 'nocard' : 'card' }}" (click)="clickItem(num)">
			<p>Item</p>
			<div *ngIf="item.cardType !== cardType.blank" class="itemCard" [class.clickable]="itemClickable(item)">
				<h1 [innerHTML]="item.itemName"></h1>
				<div>
					<h2 class="itemText" [innerHTML]="item.itemText"></h2>
					<p *ngIf="item.itemType % itemType.useOnce === 0">Discard after use</p>
					<p *ngIf="item.itemType % itemType.useNow  === 0">Use immediately or not at all</p>
					<p *ngIf="item.itemType % itemType.useNext === 0">Use next turn or not at all</p>
					<p *ngIf="item.itemType % itemType.discAny === 0">Discard any item to use</p>
					<p *ngIf="item.itemType % itemType.discTwo === 0">Discard two items to use</p>
					<h3 *ngIf="item.itemStats && item.itemStats.Brains "><span *ngIf="item.itemStats.Brains  > 0">+</span>{{ item.itemStats.Brains  }} Brains</h3>
					<h3 *ngIf="item.itemStats && item.itemStats.Brawn  "><span *ngIf="item.itemStats.Brawn   > 0">+</span>{{ item.itemStats.Brawn   }} Brawn</h3>
					<h3 *ngIf="item.itemStats && item.itemStats.Bravado"><span *ngIf="item.itemStats.Bravado > 0">+</span>{{ item.itemStats.Bravado }} Bravado</h3>
				</div>
				<div *ngIf="item.leftGem != null" class="leftGem"><div>
					<div class="leftGemAttr" *ngIf="(item.leftGem % gemType.Brains === 0) || (item.leftGem % gemType.Brawn === 0) || (item.leftGem % gemType.Bravado === 0)">
						<div [class.leftGemBrains]="item.leftGem % gemType.Brains === 0"></div>
						<div [class.leftGemBrawn]="item.leftGem % gemType.Brawn === 0"></div>
						<div [class.leftGemBravado]="item.leftGem % gemType.Bravado === 0"></div>
					</div>
					<div *ngIf="item.leftGem % gemType.vsEnemies === 0">vs Enemies</div>
					<div *ngIf="item.leftGem % gemType.vsTraps === 0">vs Traps</div>
					<div *ngIf="item.leftGem % gemType.allRolls === 0">All Rolls</div>
					<div *ngIf="item.leftGem % gemType.enBrains === 0">Enemy Brains</div>
					<div *ngIf="item.leftGem % gemType.enBrawn === 0">Enemy Brawn</div>
					<div *ngIf="item.leftGem % gemType.enBravado === 0">Enemy Bravado</div>
					<div *ngIf="item.leftGem % gemType.enemyRoll === 0">Enemy Rolls Against You</div>
					<div *ngIf="item.leftGem % gemType.trapRoll === 0">Trap Rolls Against You</div>
				</div></div>
				<div *ngIf="item.rightGem != null" class="rightGem"><div>
					<h1><span *ngIf="item.rightGem > 0">+</span>{{ item.rightGem }}</h1>
				</div></div>
			</div>
		</div>
	</div>
</div>
